<template>
  <div class="col-md-8 col-lg-6  col-sm-12" v-if="showPrice">
    <h2 class="titlePage_subtitle titlePage titlePage_mb">Order Summary #{{this.items.order_id}}</h2>
    <table class="table table_stripe" v-if="price">
      <tr class="table_bg">
        <td class="text_white">TOTAL INVESTMENT</td>
        <td class="text_white">
          <span class=""
                @click="openSettings"
                v-if="items.actions && items.actions.can_edit && showSettings"
          >
            <font-awesome-icon class="" icon="sliders-h"/>
          </span>
        </td>
      </tr>
      <tr>
        <td>Products Total</td>
        <td>
          <span class="text_link"
                @click="openTotalPrice"
                v-if="items.actions && items.actions.can_edit && showSettings"
          >$ {{showPrice? refactorPrice(price.products_total): 'xxxxx.xx'}}</span>
          <span v-else>$ {{showPrice? refactorPrice(price.products_total): 'xxxxx.xx'}}</span>
        </td>
      </tr>
      <tr v-if="price.discount">
        <td>Discount</td>
        <td>$ {{showPrice? refactorPrice(price.discount): 'xxxxx.xx'}}</td>
      </tr>
      <tr v-if="price.installation_fee">
        <td>Installation Fee</td>
        <td>$ {{showPrice? refactorPrice(price.installation_fee): 'xxxxx.xx'}}</td>
      </tr>
      <tr v-if="price.shipping_and_handling">
        <td>Shipping and Handling</td>
        <td>$ {{showPrice? refactorPrice(price.shipping_and_handling): 'xxxxx.xx'}}</td>
      </tr>
      <tr v-if="price.powder_coating_fee != 0">
        <td>Powder Coating Fee</td>
        <td>$ {{showPrice? refactorPrice(price.powder_coating_fee): 'xxxxx.xx'}}</td>
      </tr>
      <tr v-if="price.order_sub_total">
        <td><strong>Order Sub Total</strong></td>
        <td><strong>$ {{showPrice? refactorPrice(price.order_sub_total): 'xxxxx.xx'}}</strong></td>
      </tr>
      <tr v-if="price.gst != 0">
        <td>GST</td>
        <td>$ {{showPrice? refactorPrice(price.gst): 'xxxxx.xx'}}</td>
      </tr>
      <tr class="table_bg">
        <td class="text_white">ORDER TOTAL</td>
        <td class="text_white">AUD ${{showPrice? refactorPrice(price.order_total): 'xxxxx.xx'}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {changePriceForm} from '../../../helpers/aroundPrice'
  import * as abilityNames from '@/components/../helpers/abilityNames'

  export default {
    name: "OrderSummary",

    data(){
      return {
        price: '',
        abilityNames,
      }
    },
    mounted() {
      this.$store.dispatch('auth/updateAbilities')
    },
    props: {
      showSettings: {
        type: Boolean,
        default: true,
      }
    },
    watch: {
      items(){
        return this.price = this.items.price
      }
    },

    methods: {
      openSettings() {
        return this.$store.commit('orderPreview/setSettingsWindow', true);
      },

      openTotalPrice() {
        return this.$store.commit('orderPreview/setTotalPriceWindow', true);
      },

      refactorPrice(price){
        return changePriceForm(price)
      }
    },
    computed: {
      ...mapGetters('orderPreview', ['items']),
      ...mapGetters('auth', ['can']),
      showPrice() {
        return this.can(abilityNames.SEE_PRICE)
      }
    },
  }
</script>
